module.exports = __webpack_public_path__ + "static/media/axis.970627d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/axis.svg
// module id = 3575
// module chunks = 0